module.exports = __webpack_public_path__ + "cancellara-dist/img/immagine-pagina-prodotto.0efe6c9c.jpg";